module.exports = __webpack_public_path__ + "static/media/launchpad.540c4be9.svg";